module.exports = __webpack_public_path__ + "img/icon_ksvipslt.39a1291c.png";